import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  height: 1px;
  background: var(--light-gray);
  width: 100%;
`

export default class Divider extends Component {
  render() {
    return <Box {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Divider.js